import moment from 'moment'
import objectPath from 'object-path'
import httpClient from 'utility/httpClient.util'
import PNotify from 'pnotify/dist/es/PNotify'
import {
  isExternalApiUrl,
  ROUTE_API,
  ROUTE_HIS,
} from 'designer/component/action/Config'
import cloneDeep from 'clone-deep'
import { getCheckValue } from 'designer/component/action/Data'
import {
  onCallAPIAction,
  onCheckCondition,
} from 'designer/component/action/condition/Action'
import {
  createAllGetApiGroup,
  createApiSchema,
  fetchAfterSuccess,
  getApi,
  setHeadersConfig,
  setTableApi,
} from 'designer/component/action/Api'
import { convertValueBySchema } from '../button/Request'
import { Resolver } from '@stoplight/json-ref-resolver'
import { getFormGroup } from 'designer/component/action/FormGroup'
import { getPath } from 'designer/component/action/Action'
import dayjs from 'dayjs'
import { isDateValid } from 'designer/component/action/Date'
import { updateJsonTable, updateSyncTable } from './action/EditRow'
import { getRowId, getRowIndex } from './action/index'
import { isEmpty } from 'designer/component/action/condition/State'

// ============= EXPORT FUNCTION ============= //

export const createTableStyle = (column, uischema) => {
  column.headerStyle = { overflow: 'hidden' }
  if (column.textAlign) {
    column.headerStyle = {
      ...column.headerStyle,
      textAlign: column.textAlign,
    }
    column.cellStyle = {
      ...column.cellStyle,
      textAlign: column.textAlign,
    }
  }
  if (column.minWidth) {
    column.headerStyle = {
      ...column.headerStyle,
      minWidth: column.minWidth,
    }
    column.cellStyle = { ...column.cellStyle, minWidth: column.minWidth }
  }
  if (column.maxWidth) {
    column.headerStyle = {
      ...column.headerStyle,
      width: column.maxWidth,
      maxWidth: column.maxWidth,
    }
    column.cellStyle = {
      ...column.cellStyle,
      width: column.maxWidth,
      maxWidth: column.maxWidth,
    }
  }
  if (uischema.rowPadding) {
    column.headerStyle = {
      ...column.headerStyle,
      padding: uischema.rowPadding,
    }
    column.cellStyle = {
      ...column.cellStyle,
      padding: uischema.rowPadding,
    }
  } else {
    column.cellStyle = {
      ...column.cellStyle,
      padding: '16px',
    }
  }
  return column
}

export const goToForm = (
  action,
  history,
  rowData,
  designContext,
  historyContext,
  useTimeFormat,
) => {
  const { jsonForm, urlParams } = designContext
  const datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const { setHistoryState } = historyContext

  let path = `/display/form/${action.formCode}`
  path = getPath(path, action, urlParams)

  let queryString = getQueryString(action, jsonForm, {
    rowData,
    urlParams,
    datasourceValue,
    useTimeFormat,
  })

  let historyData = {
    pathname: path,
    search: '?' + queryString.join('&'),
  }

  let routerHistory = getRouterHistory(action, rowData, jsonForm)

  let pageCode = objectPath.get(jsonForm, 'props.system.props.pageCode.value')
  if (pageCode) {
    routerHistory.push({
      prop: 'pageCode',
      propType: 'system',
      value: pageCode,
    })
  }
  if (action?.sessionBackPath) {
    let sessionBackPath = localStorage.getItem('sessionBackPath') || ''
    sessionBackPath = sessionBackPath ? JSON.parse(sessionBackPath) : {}
    objectPath.set(sessionBackPath, path, {
      backPath: action.sessionBackPath,
      useLocationSearch: action.sessionLocationSearch,
    })
    localStorage.setItem('sessionBackPath', JSON.stringify(sessionBackPath))
  }
  if (action?.openNewTab) {
    let path = historyData.pathname + historyData.search
    window.open(ROUTE_HIS + path, '_blank')
  } else {
    historyData.state = routerHistory
    history.push(historyData)
    setHistoryState(historyData)
  }
}

export const goToPage = (
  action,
  history,
  rowData,
  designContext,
  historyContext,
  tableKey,
) => {
  const { jsonForm, isUiChanged, setIsUiChanged, urlParams } = designContext
  const datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const { setHistoryState } = historyContext
  let formCode = action.formCode
  if (!formCode) return
  const { perspectiveRoute = '' } = action
  let path = `/display/page/${formCode}`
  path = getPath(path, action, urlParams)

  let queryString = getQueryString(action, jsonForm, {
    rowData,
    urlParams,
    datasourceValue,
  })

  let historyData = {
    pathname: path,
    search: '?' + queryString.join('&'),
  }

  let routerHistory = getRouterHistory(action, rowData, jsonForm)

  let pageCode = objectPath.get(jsonForm, 'props.system.props.pageCode.value')
  if (pageCode) {
    routerHistory.push({
      prop: 'pageCode',
      propType: 'system',
      value: pageCode,
    })
  }
  if (action?.sessionBackPath) {
    let sessionBackPath = localStorage.getItem('sessionBackPath') || ''
    sessionBackPath = sessionBackPath ? JSON.parse(sessionBackPath) : {}
    objectPath.set(sessionBackPath, path, {
      backPath: action.sessionBackPath,
      useLocationSearch: action.sessionLocationSearch,
    })
    localStorage.setItem('sessionBackPath', JSON.stringify(sessionBackPath))
  }
  if (action?.openNewTab) {
    let path = historyData.pathname + historyData.search
    window.open(path, '_blank')
  } else {
    historyData.state = routerHistory
    history.push(historyData)
    setHistoryState(historyData)
  }
  if (jsonForm.formCode === formCode) {
    objectPath.set(isUiChanged, 'renderPage', { formCode, tableKey })
    setIsUiChanged(isUiChanged)
  } else {
    objectPath.del(isUiChanged, 'renderPage')
    setIsUiChanged(isUiChanged)
  }
}

export const goToUrl = (action, uischema, rowData, designContext, location) => {
  const { jsonForm, searchData } = designContext
  let url = ''
  let linkType = action.linkType
  if (linkType === 'samePath') {
    let { pathname } = location
    url = pathname
  } else if (linkType === 'internal') {
    url = action.pagePath
  } else if (linkType === 'external') {
    url = action.url
  } else if (linkType === 'api') {
    let { apiType, service = '', endpoint = '', api = '' } = action
    url = apiType === 'internal' ? service + endpoint : api
  }
  let name = objectPath.get(uischema, 'loadData.search.name')
  let formData = jsonForm.formData
  let propData = name ? jsonForm.formData.props[name] : {}
  if (action.pathParams) {
    let pathParams = action.pathParams
    pathParams.forEach(({ param, key, value }) => {
      if (key) {
        value =
          objectPath.get(searchData, key) ||
          objectPath.get(rowData, key) ||
          objectPath.get(propData, key) ||
          objectPath.get(formData, key) ||
          ''
      }
      url = url.replace(`:${param}`, value)
    })
  }

  let query = []
  if (action.queryParams) {
    let queryParams = action.queryParams
    queryParams.forEach(({ param, key, value }) => {
      if (key) {
        value =
          objectPath.get(searchData, key) ||
          objectPath.get(rowData, key) ||
          objectPath.get(propData, key) ||
          objectPath.get(formData, key) ||
          ''
      }
      if (value !== null && value !== undefined) {
        query.push(`${param}=${value}`)
      }
    })
    url = query.length > 0 ? url + '?' + query.join('&') : url
  }
  let isRenderComponent = action.renderComponent
  if (isRenderComponent) {
    let pagePath = action.pagePath
    let { pathname } = location
    query.push(`component=${pagePath}`)
    let url = query.length > 0 ? pathname + '?' + query.join('&') : pathname
    window.open(ROUTE_HIS + url, '_self')
  } else {
    let target = action.openNewTab ? '_blank' : '_self'
    if (linkType === 'api') {
      if (url.startsWith('/')) {
        window.open(ROUTE_API + url, target)
      } else {
        window.open(`${ROUTE_API}/` + url, target)
      }
    } else if (isExternalApiUrl(linkType, url)) {
      window.open(url, target)
    } else if (url.startsWith('http')) {
      window.open(url, target)
    } else if (url.startsWith('/')) {
      window.open(ROUTE_HIS + url, target)
    } else {
      window.open(`${ROUTE_HIS}/` + url, target)
    }
  }
}

const getModal = (form, modalKey, findUischemaIndex) => {
  let elements = form.uischema.elements
  let mapKey = form.schema.mapKey[modalKey]
  let indices = findUischemaIndex(modalKey, mapKey, elements)
  let modalElement = indices.reduce((o, i) => o.elements[i], { elements })
  return modalElement
}

const isNumber = (a) => Number(a) === +a

export const goToModal = async (
  action,
  modalKey,
  rowData,
  designContext,
  uischema,
) => {
  const {
    jsonForm,
    setSendProps,
    setDesignerPropsData,
    findUischemaIndex,
    setUischema,
    setOpenModal,
    isUiChanged,
    setIsUiChanged,
  } = designContext
  let formData = {}

  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let propList =
    typeof action.props === 'object'
      ? Object.values(action.props)
      : action.props

  if (Array.isArray(propList) && propList.length > 0) {
    let data = {}
    propList.forEach(
      ({
        prop,
        propType,
        value = '',
        key = '',
        elementKey,
        systemType,
        fullPropKey,
        jsonKey,
      }) => {
        if (systemType === 'table') {
          let value = jsonKey ? objectPath.get(rowData, jsonKey) : rowData
          if (jsonKey) {
            objectPath.set(data, fullPropKey, value)
          } else {
            objectPath.set(data, prop, value)
          }
        } else if (propType === 'condition') {
          objectPath.set(data, prop, 1)
        } else if (propType === 'custom') {
          if (isNumber(value)) {
            objectPath.set(data, prop, Number(value))
          } else {
            objectPath.set(data, prop, value)
          }
        } else if (propType === 'input') {
          let dataKey = objectPath.get(formData, key)
          let dataProp = objectPath.get(formData, prop)
          objectPath.set(data, prop, dataKey || dataProp || '')
        } else if (propType === 'table') {
          objectPath.set(data, prop, rowData)
        } else if (propType === 'datasource') {
        } else {
          let data = null
          if (elementKey === uischema.key) {
            data = rowData
          } else {
            data = objectPath.get(formData, value || prop)
          }
        }
      },
    )
    objectPath.set(designerPropsData, `data.${uischema.key}`, data)
    setDesignerPropsData(designerPropsData)
    setSendProps(data)
  }

  if (action.modalType === 'internal') {
    if (!modalKey) return
    let elements = jsonForm.uischema.elements
    let modalElement = getModal(jsonForm, modalKey, findUischemaIndex)
    modalElement.isOpen = true
    let newUiSchema = jsonForm.uischema
    newUiSchema.elements = elements
    setUischema(newUiSchema)
    setOpenModal(modalKey)
  } else if (action.modalType === 'external') {
    objectPath.set(designerPropsData, 'modal', action.formCode)
    setDesignerPropsData(designerPropsData)
    setOpenModal(uischema.key)
    if (uischema.tagname === 'customTable') {
      objectPath.set(isUiChanged, ['openModalTable', uischema.key], true)
      objectPath.set(isUiChanged, ['modalAction', uischema.key], action)
      setIsUiChanged(isUiChanged)
    }
  } else if (action.modalType === 'component') {
    objectPath.set(designerPropsData, 'modal', action.component)
    setDesignerPropsData(designerPropsData)
  } else if (action.modalType === 'jsonForm') {
    objectPath.set(isUiChanged, 'modalJson', {
      isOpen: true,
      action,
      rowData,
      uischema,
    })
    setIsUiChanged(isUiChanged)
  }
}

export const printData = (action, data, isList = false) => {
  let { dataSelected } = data
  let selectedList = Array.isArray(dataSelected)
    ? dataSelected
    : dataSelected
    ? [dataSelected]
    : []
  if (action.printType === 'internal') {
    if (action.printPerRow) {
      selectedList.forEach((rowData) => {
        printInternal(action, { ...data, rowData })
      })
    } else {
      printInternal(action, data)
    }
  } else if (action.printType === 'external') {
    if (action.printPerRow) {
      selectedList.forEach((rowData) => {
        printExternal(action, { ...data, rowData })
      })
    } else {
      printExternal(action, data)
    }
  }
}

export const printInternal = (action, data) => {
  let {
    rowData = {},
    formData = {},
    datasourceValue = {},
    designerData = {},
  } = data

  let { pagePath = '', pathParams = [], queryParams = [] } = action
  if (pathParams) {
    pathParams.forEach(({ param, propType, value, key, sourceKey }) => {
      if (propType === 'input') {
        value = objectPath.get(formData, key) || ''
      } else if (propType === 'condition') {
      } else if (propType === 'system') {
        value =
          objectPath.get(designerData, key) || objectPath.get(formData, key)
      } else if (propType === 'datasource') {
        value = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (key) {
        value = objectPath.get(rowData, key) || ''
      } else {
        value = ''
      }
      pagePath = pagePath.replace(`:${param}`, value)
    })
  }
  if (queryParams) {
    let queryString = []
    queryParams.forEach(({ param, propType, value, key, sourceKey }) => {
      if (propType === 'input') {
        value = objectPath.get(formData, key) || ''
      } else if (propType === 'condition') {
      } else if (propType === 'system') {
        value =
          objectPath.get(designerData, key) || objectPath.get(formData, key)
      } else if (propType === 'datasource') {
        value = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (key) {
        value = objectPath.get(rowData, key) || ''
      } else {
        value = ''
      }
      queryString.push(`${param}=${value}`)
    })
    if (queryString) {
      let connect = pagePath.indexOf('?') > -1 ? '&' : '?'
      pagePath = pagePath
        ? pagePath + connect + queryString.join('&')
        : pagePath
    }
  }
  if (pagePath.startsWith('/')) {
    window.open(ROUTE_HIS + pagePath, '_blank')
  } else {
    window.open(`${ROUTE_HIS}/` + pagePath, '_blank')
  }
}

export const printExternal = (action, data) => {
  let {
    rowData = {},
    formData = {},
    datasourceValue = {},
    designerData = {},
  } = data

  let { url = '', pathParams = [], queryParams = [] } = action
  if (pathParams) {
    pathParams.forEach(({ param, propType, value, key, sourceKey }) => {
      if (propType === 'input') {
        value = objectPath.get(formData, key) || ''
      } else if (propType === 'condition') {
      } else if (propType === 'system') {
        value =
          objectPath.get(designerData, key) || objectPath.get(formData, key)
      } else if (propType === 'datasource') {
        value = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (key) {
        value = objectPath.get(rowData, key) || ''
      } else {
        value = ''
      }
      url = url.replace(`:${param}`, value)
    })
  }
  if (queryParams) {
    let queryString = []
    queryParams.forEach(({ param, propType, value, key, sourceKey }) => {
      if (propType === 'input') {
        value = objectPath.get(formData, key) || ''
      } else if (propType === 'condition') {
      } else if (propType === 'system') {
        value =
          objectPath.get(designerData, key) || objectPath.get(formData, key)
      } else if (propType === 'datasource') {
        value = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (key) {
        value = objectPath.get(rowData, key) || ''
      } else {
        value = ''
      }
      queryString.push(`${param}=${value}`)
    })
    if (queryString) {
      let connect = url.indexOf('?') > -1 ? '&' : '?'
      url = url ? url + connect + queryString.join('&') : url
    }
  }
  window.open(url, '_blank')
}

export const getData = async ({
  action,
  rowData,
  designContext,
  renderTableData,
  allParams,
}) => {
  const { jsonForm, setFormData } = designContext
  const datasourceValue = objectPath.get(designContext, '@datasource')
  let {
    mapReceiveKey,
    isGroup,
    requestDataType,
    formName,
    customName,
    headers = [],
  } = action

  rowData = Array.isArray(rowData) ? rowData : [rowData]

  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }

  return Promise.all(
    rowData.map(async (values) => {
      let api = setTableApi(action, {
        formData: jsonForm.formData,
        designContext,
        allParams,
        rowData: values,
        datasourceValue,
      })
      if (!api) return
      let responseData = null
      let config = {}
      if (headers.length > 0) {
        headers.forEach(({ key, value }) => {
          if (key) {
            objectPath.set(config, `headers.${key}`, value)
          }
        })
      }

      // send request
      responseData = await httpClient
        .get(api, config)
        .then((response) => {
          doAfter(action, response, designContext)
          return response.data
        })
        .catch((error) => {
          if (error.response) {
            let response = {
              status: error.response.status,
              message: error.response.data,
              data: null,
            }
            doAfter(action, response, designContext)
            return response
          }
        })

      // set data
      let formData = jsonForm.formData

      if (responseData && Object.values(responseData).length > 0) {
        Object.keys(mapReceiveKey).forEach((key) => {
          let name = mapReceiveKey[key]

          if (isGroup) {
            // group
            let [secondKey, lastKey] = key.split('.')
            formData[lastKey] = responseData[secondKey][name]
            formData[name] = responseData[secondKey][name]
          } else {
            // no group
            formData[key] = responseData[name]
            formData[name] = responseData[name]
          }
        })
      } else {
        Object.keys(mapReceiveKey).forEach((key) => {
          let name = mapReceiveKey[key]
          formData[key] = ''
          formData[name] = ''
        })
      }
      if (requestDataType === 'customData' && customName) {
        formData.props = {
          ...formData.props,
          [customName]: responseData,
        }
      }
      if (requestDataType === 'formData' && formName) {
        formData.props = {
          ...formData.props,
          [formName]: responseData,
        }
      }
      setFormData(formData)
    }),
  )
    .catch((error) => {
      console.error('There was an error!', error)
    })
    .then(() => renderTableData())
}

export const postData = async ({
  action,
  rowData,
  designContext,
  renderTableData,
  allParams,
  user,
  uischema,
  isFavoriteFetch,
}) => {
  const { jsonForm, isUiChanged, setIsUiChanged } = designContext
  const datasourceValue = objectPath.get(designContext, '@datasource')
  rowData = Array.isArray(rowData) ? rowData : [rowData]
  let tableColumn = uischema?.tableColumn || []

  let { headers = [] } = action
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }
  const resolver = new Resolver()
  let apiSchema = await createApiSchema(
    { ...action, method: 'post' },
    designContext,
    resolver,
  )
  return Promise.all(
    rowData.map(async (values) => {
      let api = setTableApi(action, {
        formData: jsonForm.formData,
        designContext,
        allParams,
        rowData: values,
        datasourceValue,
      })
      if (!api) return
      // set request body
      let requestData = setRequestData(
        action,
        jsonForm,
        values,
        datasourceValue,
        user,
        tableColumn,
        apiSchema,
      )
      if (!requestData) return
      await httpClient
        .post(api, requestData, config)
        .then((response) => doAfter(action, response, designContext, uischema))
        .catch((error) => {
          if (error.response) {
            let response = {
              status: error.response.status,
              message: error.response.data,
              data: null,
            }
            doAfter(action, response, designContext)
            return response
          }
        })
    }),
  )
    .catch((error) => {
      console.error('There was an error!', error)
    })
    .then(() => {
      let renderPromise = Promise.resolve()
      let isWaitFetchApiTable = objectPath.get(
        isUiChanged,
        'isWaitFetchApiTable',
      )
      if (isFavoriteFetch) {
        renderPromise = renderTableData(uischema)
      } else if (isWaitFetchApiTable) {
        objectPath.del(isUiChanged, 'isWaitFetchApiTable')
        objectPath.set(isUiChanged, [uischema.key], {
          isConfirmFetchApiTable: true,
        })
        setIsUiChanged(isUiChanged)
      } else {
        renderPromise = renderTableData(uischema, false, true)
      }
      fetchAfterSuccess({ action, designContext })
      return renderPromise
    })
}

export const putData = async ({
  action,
  rowData,
  designContext,
  renderTableData,
  allParams,
  user,
  uischema,
}) => {
  const { jsonForm, isUiChanged, setIsUiChanged } = designContext
  const datasourceValue = objectPath.get(designContext, '@datasource')
  rowData = Array.isArray(rowData) ? rowData : [rowData]
  let tableColumn = uischema?.tableColumn || []

  let { headers = [] } = action
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }
  const resolver = new Resolver()
  let apiSchema = await createApiSchema(
    { ...action, method: 'put' },
    designContext,
    resolver,
  )
  return Promise.all(
    rowData.map(async (values) => {
      let api = setTableApi(action, {
        formData: jsonForm.formData,
        designContext,
        allParams,
        rowData: values,
        datasourceValue,
      })
      if (!api) return
      // set request body
      let requestData = setRequestData(
        action,
        jsonForm,
        values,
        datasourceValue,
        user,
        tableColumn,
        apiSchema,
      )
      if (!requestData) return
      await httpClient
        .put(api, requestData, config)
        .then((response) => doAfter(action, response, designContext, uischema))
        .catch((error) => {
          if (error.response) {
            let response = {
              status: error.response.status,
              message: error.response.data,
              data: null,
            }
            doAfter(action, response, designContext)
            return response
          }
        })
    }),
  )
    .catch((error) => {
      console.error('There was an error!', error)
    })
    .then(() => {
      let renderPromise = Promise.resolve()
      let isWaitFetchApiTable = objectPath.get(
        isUiChanged,
        'isWaitFetchApiTable',
      )
      if (isWaitFetchApiTable) {
        objectPath.del(isUiChanged, 'isWaitFetchApiTable')
        objectPath.set(isUiChanged, [uischema.key], {
          isConfirmFetchApiTable: true,
        })
        setIsUiChanged(isUiChanged)
      } else {
        renderPromise = renderTableData(uischema, false, true)
      }
      fetchAfterSuccess({ action, designContext })
      return renderPromise
    })
}

export const patchData = async ({
  action,
  rowData,
  designContext,
  renderTableData,
  allParams,
  user,
  uischema,
}) => {
  const { jsonForm, isUiChanged, setIsUiChanged } = designContext
  const datasourceValue = objectPath.get(designContext, '@datasource')
  rowData = Array.isArray(rowData) ? rowData : [rowData]
  let tableColumn = uischema?.tableColumn || []

  let { headers = [] } = action
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }
  const resolver = new Resolver()
  let apiSchema = await createApiSchema(
    { ...action, method: 'patch' },
    designContext,
    resolver,
  )

  return Promise.all(
    rowData.map(async (values) => {
      let api = setTableApi(action, {
        formData: jsonForm.formData,
        designContext,
        allParams,
        rowData: values,
        datasourceValue,
      })
      if (!api) return
      // set request body
      let requestData = setRequestData(
        action,
        jsonForm,
        values,
        datasourceValue,
        user,
        tableColumn,
        apiSchema,
      )
      if (!requestData) return
      await httpClient
        .patch(api, requestData, config)
        .then((response) => doAfter(action, response, designContext, uischema))
        .catch((error) => {
          if (error.response) {
            let response = {
              status: error.response.status,
              message: error.response.data,
              data: null,
            }
            doAfter(action, response, designContext)
            return response
          }
        })
    }),
  )
    .catch((error) => {
      console.error('There was an error!', error)
    })
    .then(() => {
      let renderPromise = Promise.resolve()
      let isWaitFetchApiTable = objectPath.get(
        isUiChanged,
        'isWaitFetchApiTable',
      )
      if (isWaitFetchApiTable) {
        objectPath.del(isUiChanged, 'isWaitFetchApiTable')
        objectPath.set(isUiChanged, [uischema.key], {
          isConfirmFetchApiTable: true,
        })
        setIsUiChanged(isUiChanged)
      } else {
        renderPromise = renderTableData(uischema, false, true)
      }
      fetchAfterSuccess({ action, designContext })
      return renderPromise
    })
}

export const deleteData = async ({
  action,
  rowData,
  designContext,
  renderTableData,
  allParams,
  uischema,
  setRowPanelAdd,
}) => {
  const { jsonForm } = designContext
  const datasourceValue = objectPath.get(designContext, '@datasource')
  if (objectPath.get(rowData, '@isAdd')) {
    setRowPanelAdd([])
    return Promise.resolve()
  } else {
    rowData = Array.isArray(rowData) ? rowData : [rowData]

    let { headers = [] } = action
    let config = {}
    if (headers.length > 0) {
      headers.forEach(({ key, value }) => {
        if (key) {
          objectPath.set(config, `headers.${key}`, value)
        }
      })
    }
    return Promise.all(
      rowData.map(async (values) => {
        let api = setTableApi(action, {
          formData: jsonForm.formData,
          designContext,
          allParams,
          rowData: values,
          datasourceValue,
        })
        if (!api) return
        // set request body
        await httpClient
          .delete(api, config)
          .then((response) =>
            doAfter(action, response, designContext, uischema),
          )
          .catch((error) => {
            if (error.response) {
              let response = {
                status: error.response.status,
                message: error.response.data,
                data: null,
              }
              doAfter(action, response, designContext)
              return response
            }
          })
      }),
    ).then(() => {
      let renderPromise = renderTableData(uischema, false, true)
      fetchAfterSuccess({ action, designContext })
      return renderPromise
    })
  }
}

export const createAndUpdate = async ({
  action,
  rowData,
  designContext,
  renderTableData,
  allParams,
  user,
}) => {
  let { post, put, customData, requestDataType } = action
  let { jsonForm } = designContext
  let isUpdate = true
  let isCreate = true
  if (post.condition.pathParams) {
    let pathParams = post.pathParams
    let filterNoValue = pathParams.filter(({ key, propType }) => {
      let value = ''
      if (propType === 'table') {
        value = objectPath.get(rowData, key) || ''
      } else if (propType === 'input') {
        value = objectPath.get(jsonForm.formData, key) || ''
      }
      if (!value) {
        return true
      }
      return false
    })
    if (filterNoValue.length > 0) {
      isCreate = false
    }
  }
  if (post.condition.queryParams) {
    let queryParams = post.queryParams
    let filterNoValue = queryParams.filter(({ key, propType }) => {
      let value = ''
      if (propType === 'table') {
        value = objectPath.get(rowData, key) || ''
      } else if (propType === 'input') {
        value = objectPath.get(jsonForm.formData, key) || ''
      }
      if (!value) {
        return true
      }
      return false
    })
    if (filterNoValue.length > 0) {
      isCreate = false
    }
  }
  if (post.condition.requestBody) {
    let filterNoValue = []
    if (requestDataType === 'customData') {
      filterNoValue = customData.filter(({ key, propType, isCreate }) => {
        if (isCreate) {
          let value = ''
          if (propType === 'table') {
            value = objectPath.get(rowData, key) || ''
          } else if (propType === 'input') {
            value = objectPath.get(jsonForm.formData, key) || ''
          }
          if (!value) {
            return true
          }
        }
        return false
      })
      if (filterNoValue.length > 0) {
        isCreate = false
      }
    }
    if (requestDataType === 'formData') {
      let { isGroup, groupData } = action
      if (isGroup) {
        groupData.forEach(({ data }) => {
          filterNoValue = [
            ...data.filter(({ mapKey, isCreate }) => {
              if (isCreate && !jsonForm.formData[mapKey]) {
                return true
              }
              return false
            }),
          ]
          if (filterNoValue.length > 0) {
            isCreate = false
          }
        })
      } else {
        filterNoValue = groupData.data.filter(({ mapKey, isCreate }) => {
          if (isCreate && !jsonForm.formData[mapKey]) {
            return true
          }
          return false
        })
        if (filterNoValue.length > 0) {
          isCreate = false
        }
      }
    }
  }

  if (put.condition.pathParams) {
    let pathParams = put.pathParams
    let filterNoValue = pathParams.filter(({ key, propType }) => {
      let value = ''
      if (propType === 'table') {
        value = objectPath.get(rowData, key) || ''
      } else if (propType === 'input') {
        value = objectPath.get(jsonForm.formData, key) || ''
      }
      if (!value) {
        return true
      }
      return false
    })
    if (filterNoValue.length > 0) {
      isUpdate = false
    }
  }
  if (put.condition.queryParams) {
    let queryParams = put.queryParams
    let filterNoValue = queryParams.filter(({ key, propType }) => {
      let value = ''
      if (propType === 'table') {
        value = objectPath.get(rowData, key) || ''
      } else if (propType === 'input') {
        value = objectPath.get(jsonForm.formData, key) || ''
      }
      if (!value) {
        return true
      }
      return false
    })
    if (filterNoValue.length > 0) {
      isUpdate = false
    }
  }
  if (put.condition.requestBody) {
    let filterNoValue = []
    if (requestDataType === 'customData') {
      filterNoValue = customData.filter(({ key, propType, isUpdate }) => {
        if (isUpdate) {
          let value = ''
          if (propType === 'table') {
            value = objectPath.get(rowData, key) || ''
          } else if (propType === 'input') {
            value = objectPath.get(jsonForm.formData, key) || ''
          }
          if (!value) {
            return true
          }
        }
        return false
      })
      if (filterNoValue.length > 0) {
        isUpdate = false
      }
    }
    if (requestDataType === 'formData') {
      let { isGroup, groupData } = action
      if (isGroup) {
        groupData.forEach(({ data }) => {
          filterNoValue = [
            ...data.filter(({ mapKey, isUpdate }) => {
              if (isUpdate && !jsonForm.formData[mapKey]) {
                return true
              }
              return false
            }),
          ]
          if (filterNoValue.length > 0) {
            isUpdate = false
          }
        })
      } else {
        filterNoValue = groupData.data.filter(({ mapKey, isUpdate }) => {
          if (isUpdate && !jsonForm.formData[mapKey]) {
            return true
          }
          return false
        })
        if (filterNoValue.length > 0) {
          isUpdate = false
        }
      }
    }
  }

  if (isCreate) {
    if (isUpdate) {
      putData({
        action: { ...action, ...put },
        rowData,
        designContext,
        renderTableData,
        allParams,
        user,
      })
    } else {
      postData({
        action: { ...action, ...post },
        rowData,
        designContext,
        renderTableData,
        allParams,
        user,
      })
    }
  } else {
    if (isUpdate) {
      putData({
        action: { ...action, ...put },
        rowData,
        designContext,
        renderTableData,
        allParams,
        user,
      })
    }
  }
}

export const showAndHide = (action, designContext) => {
  let { updateUiSchema, getCurrentUi } = designContext
  let { show = [], hide = [] } = action
  show.forEach(({ value = '' }) => {
    if (value) {
      updateUiSchema(value, 'isShowUi', true)
    }
  })
  hide.forEach(({ value = '' }) => {
    if (value) {
      updateUiSchema(value, 'isShowUi', false)
    }
  })
}

export const mapFieldTable = (action, rowData, designContext, setRender) => {
  let { jsonForm, setFormData, getCurrentUi } = designContext
  let formData = objectPath.get(jsonForm, 'formData') || {}
  let dataTable = objectPath.get(action, 'dataTable') || []
  dataTable.forEach(({ response, value, key }) => {
    if (response && value) {
      let ui = getCurrentUi(key)
      if (ui.key === key) {
        let rowValue = objectPath.get(rowData, response)
        objectPath.set(formData, ui.key, rowValue)
        objectPath.set(formData, ui.name, rowValue)
      }
    }
  })
  setFormData(formData)
  setRender(true)
}

export const mapToData = async (
  uischema,
  rowData,
  designContext,
  createClickRow,
) => {
  let isSameSelected = createClickRow(rowData)
  let { action } = uischema
  let { jsonForm, setFormData, getCurrentUi, setIsUiChanged, isUiChanged } =
    designContext
  let formData = objectPath.get(jsonForm, 'formData') || {}
  let dataTable = objectPath.get(action, 'dataTable') || []
  const allFormGroup = getFormGroup(designContext)
  const allBulkGroup = jsonForm?.bulkGroup || []
  let mapTag = jsonForm.schema.mapTag
  let mapKey = jsonForm.schema.mapKey
  let { formDataKey, bulkDataKey, requestDataType, mapColumn = [] } = action
  if (requestDataType === 'single') {
    let form = allFormGroup.find((form) => form.key === formDataKey)
  } else if (requestDataType === 'bulk') {
    let bulkGroup = allBulkGroup.find(({ key }) => key === bulkDataKey)
    let { bulkTable = [], mainBulk = {} } = bulkGroup
    let bulkKey = mainBulk?.key
    let bulkUi = getCurrentUi(bulkKey)
    if (isSameSelected) {
      objectPath.set(isUiChanged, bulkUi.key, {
        isUnSelectedList: true,
      })
      return setIsUiChanged(isUiChanged)
    }

    bulkTable.forEach(({ key, name }) => {
      let value = objectPath.get(rowData, name)
      objectPath.set(formData, key, value)
      objectPath.set(formData, name, value)
      objectPath.set(isUiChanged, key, { isRender: true })
    })
    if (bulkUi.tagname === 'list') {
      let list = objectPath.get(formData, bulkUi.name)
      if (list === undefined) {
        let loadData = objectPath.get(bulkUi, 'loadData.get')
        let apiData = {
          formData,
          urlParams: designContext.urlParams,
          designContext,
        }
        let api = getApi(loadData, apiData)
        if (!api) return formData
        let config = setHeadersConfig(loadData)
        list = await httpClient
          .get(api, config)
          .then(({ data }) => data?.data || [])
          .catch(() => [])
      }
      let columnRefId = bulkUi?.loadData?.columnRefId
      let loadItemMethod = bulkUi?.loadItem?.method || ''
      loadItemMethod = loadItemMethod.toLowerCase()
      let loadItem = objectPath.get(bulkUi?.loadItem, loadItemMethod)
      let loadItemKey = loadItem.optionKey
      if (list && Array.isArray(list)) {
        let foundIndex = list.findIndex((itemList) => {
          let itemId = objectPath.get(itemList, columnRefId)
          let rowId = objectPath.get(rowData, columnRefId)
          return itemId === rowId
        })
        if (foundIndex === -1) return
        let rowList = list[foundIndex]
        let subListKey = Object.keys(mapTag).filter((key) => {
          let tag = mapTag[key]
          let fullKey = mapKey[key]
          return (
            tag === 'list' &&
            key !== loadItemKey &&
            fullKey.split('.').includes(loadItemKey)
          )
        })
        let isChecked = objectPath.get(rowData, '@isChecked')
        if (isChecked) {
          objectPath.set(list, [foundIndex, '@isChecked'], isChecked)
        }
        subListKey.forEach((key) => {
          let listUi = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
          let columnRefId = listUi?.loadData?.columnRefId
          let subRowList = objectPath.get(rowList, listUi.name)
          let subRowData = objectPath.get(rowData, listUi.name)
          subRowList.map((subRowItem) => {
            let itemId = objectPath.get(subRowItem, columnRefId)
            let found = subRowData.find(
              (subData) => objectPath.get(subData, columnRefId) === itemId,
            )
            if (!found) return
            let subDataIndex = subRowData.findIndex(
              (subData) =>
                objectPath.get(subData, columnRefId) ===
                objectPath.get(subRowItem, columnRefId),
            )
            if (subDataIndex === -1) return
            let subDataItem = subRowData[subDataIndex]
            let isChecked = objectPath.get(subDataItem, '@isChecked')
            if (isChecked) {
              objectPath.set(subRowItem, ['@isChecked'], isChecked)
            }
            return subRowItem
          })
          objectPath.set(list, `${foundIndex}.${listUi.name}`, subRowList)
        })
        objectPath.set(formData, bulkUi.name, list)
        objectPath.set(formData, bulkUi.key, list)
        objectPath.set(isUiChanged, bulkUi.key, {
          isSelectedList: true,
          selectedItem: { item: rowList, index: foundIndex, checked: true },
        })
      }
    }
    setFormData(formData)
    setIsUiChanged(isUiChanged)
  }
}

export const updateStatus = (
  action,
  rowData,
  onRowTableUpdate,
  genRefId,
  columnRefId,
  propAction,
) => {
  let { statusValue, statusField, isDeleteMode } = action
  if (isNumber(statusValue)) {
    statusValue = Number(statusValue)
  } else if (statusValue === 'true') {
    statusValue = true
  } else if (statusValue === 'false') {
    statusValue = false
  } else if (statusValue === 'null') {
    statusValue = null
  } else if (statusValue === 'undefined') {
    statusValue = undefined
  }
  let oldData = cloneDeep(rowData)
  let newData = {}
  if (isDeleteMode) {
    if (objectPath.has(oldData, genRefId)) {
      let id = objectPath.get(oldData, genRefId)
      objectPath.set(newData, genRefId, id)
    } else if (columnRefId && objectPath.has(oldData, columnRefId)) {
      let id = objectPath.get(oldData, columnRefId)
      objectPath.set(newData, columnRefId, id)
    }
    objectPath.set(newData, `@isDeleted`, true)
  } else {
    newData = rowData
  }
  objectPath.set(newData, statusField, statusValue)
  onRowTableUpdate(newData, oldData, propAction)
}

const getDataUpdate = (propAction) => {
  let {
    designContext,
    uischema,
    isLoadSYNC,
    syncKey,
    config,
    updateData,
    formComponentName,
  } = propAction
  let { isFavoriteModal, jsonData = [], favoriteDataKey } = config
  let { jsonForm, isUiChanged } = designContext
  let formData = jsonForm.formData
  let tableKey = isLoadSYNC ? syncKey : uischema.key
  let tableName = uischema.name
  tableKey = formComponentName ? `${formComponentName}.${tableKey}` : tableKey
  tableName = formComponentName
    ? `${formComponentName}.${tableName}`
    : tableName
  let arrayTable = objectPath.get(isUiChanged, `arrayTable.${tableKey}`)
  arrayTable = Array.isArray(arrayTable) ? arrayTable : []
  let formTable =
    objectPath.get(formData, tableName) ||
    objectPath.get(formData, tableKey) ||
    objectPath.get(formData, uischema.name) ||
    objectPath.get(formData, uischema.key) ||
    []
  formTable = Array.isArray(formTable) ? formTable : []

  let editFavorite = isUiChanged?.editFavorite
  let favoriteJson = objectPath.get(editFavorite, `jsonData.${favoriteDataKey}`)
  let dataUpdate = isFavoriteModal
    ? favoriteJson || jsonData
    : isEmpty(arrayTable)
    ? formTable
    : arrayTable
  return dataUpdate
}

const updateTable = ({ tempData, dataUpdate, propAction }) => {
  let { isLoadSYNC, config, updateData } = propAction
  let { isFavoriteModal } = config
  if (isFavoriteModal) {
    updateData(dataUpdate)
  } else if (isLoadSYNC) {
    updateSyncTable(tempData, dataUpdate, propAction)
  } else {
    updateJsonTable(tempData, dataUpdate, propAction)
  }
}

export const moveUpDown = (type, rowData, propAction) => {
  let { uischema } = propAction
  let dataUpdate = getDataUpdate(propAction)
  let currentData = cloneDeep(rowData)
  let currentId = getRowId(currentData, uischema)
  let currentIndex = getRowIndex(dataUpdate, currentId, uischema)
  let currentSeq = objectPath.get(currentData, 'seq')
  let currentTableData = objectPath.get(currentData, 'tableData')
  let tempIndex
  if (type === 'UP' && currentIndex > 0) {
    tempIndex = currentIndex - 1
  } else if (type === 'DOWN' && currentIndex < dataUpdate.length - 1) {
    tempIndex = currentIndex + 1
  }
  if (tempIndex === undefined) return
  let tempData = cloneDeep(objectPath.get(dataUpdate, tempIndex))
  let tempSeq = objectPath.get(tempData, 'seq')
  let tempTableData = objectPath.get(tempData, 'tableData')
  objectPath.set(dataUpdate, tempIndex, {
    ...currentData,
    seq: tempSeq,
    tableData: {
      ...currentTableData,
      no: tempSeq,
    },
  })
  objectPath.set(dataUpdate, currentIndex, {
    ...tempData,
    seq: currentSeq,
    tableData: {
      ...tempTableData,
      no: currentSeq,
    },
  })
  updateTable({ tempData, dataUpdate, propAction })
}

// ============= EXPORT FUNCTION ============= //

// ============= INTERNAL FUNCTION ============= //

const getQueryString = (
  action,
  jsonForm,
  { rowData, urlParams = {}, datasourceValue, useTimeFormat },
) => {
  let queryString = []
  if (action.routerParams) {
    let routerParams = action.routerParams
    routerParams.forEach(({ param, paramType, key, value }) => {
      let paramValue
      if (paramType === 'table') {
        if (key && objectPath.has(rowData, key)) {
          paramValue = objectPath.get(rowData, key)
        } else if (value && objectPath.has(rowData, value)) {
          paramValue = objectPath.get(rowData, value)
        }

        let isCheckDate = isDateValid(paramValue)
        if (isCheckDate && useTimeFormat) {
          const { formatDate } = useTimeFormat
          paramValue = formatDate(dayjs(paramValue), 'YYYY-MM-DD')
        }
      } else if (paramType === 'input') {
        paramValue = objectPath.get(jsonForm.formData, key)
      } else if (paramType === 'condition') {
        paramValue = value
      } else if (paramType === 'datasource') {
        paramValue = objectPath.get(datasourceValue, value)
      } else if (paramType === 'urlParam') {
        paramValue = objectPath.get(urlParams, value)
      }
      if (paramValue !== null && paramValue !== undefined) {
        queryString.push(`${param}=${paramValue}`)
      }
    })
  }
  return queryString
}

const getRouterHistory = (action, rowData, jsonForm) => {
  let routerHistory = objectPath.get(action, 'routerHistory') || []

  if (routerHistory.length > 0) {
    routerHistory.map((prop) => {
      let data =
        prop.systemType === 'table'
          ? rowData
          : objectPath.get(jsonForm, ['formData'])
      if (prop.propType === 'input' && prop.prop) {
        if (prop.jsonKey) {
          prop.value = objectPath.get(data, prop.jsonKey)
        } else {
          prop.value = objectPath.has(data, prop.prop)
            ? objectPath.get(data, prop.prop)
            : data
        }
      } else if (prop.propType === 'formData' && prop.propKey) {
        if (prop.jsonKey) {
          prop.value = objectPath.get(data, prop.jsonKey)
        } else {
          prop.value = data
        }
      } else if (prop.propType === 'table' && rowData) {
        prop.value = rowData
      } else {
        prop.value = data
      }
      return prop
    })
  }
  return routerHistory
}

const loadFromStorage = async (action, jsonForm) => {
  let { endpoint, pathParams, requestDataType, isGroup } = action

  if (requestDataType === 'customData') {
    let { customData } = action
    let newData = JSON.parse(localStorage.getItem('loadCustomData'))
    let formName = endpoint.split('/').shift()
    if (newData && newData[formName]) {
      let foundIndex = newData[formName].findIndex((data) => {
        let found = pathParams.find((pathParam) => {
          return customData.find(({ value }) => {
            return value === pathParam.value
          })
        })
        if (found && data[found.param] === jsonForm.formData[found.param]) {
          return data
        }
        return false
      })
      if (foundIndex > -1) {
        return newData[formName][foundIndex]
      }
    }
  } else if (requestDataType === 'formData') {
    // load data from localStorage
    let newData = JSON.parse(localStorage.getItem('loadFormData'))
    let { formName, mapReceiveKey, mapData } = action
    if (newData && newData[formName]) {
      // find data

      let foundIndex = newData[formName].findIndex((data) => {
        let found = pathParams.find((pathParam) => {
          if (isGroup) {
            // group
            let foundIndex = Object.keys(mapData).findIndex(
              (key) => key === pathParam.key,
            )
            let found = Object.keys(mapData)[foundIndex]
            if (!found) return false
            let [secondKey, lastKey] = found.split('.')
            return (
              data[secondKey][lastKey] &&
              data[secondKey][lastKey] == jsonForm.formData[pathParam.param]
            )
          } else {
            // no group
            let foundIndex = Object.keys(mapData).findIndex(
              (key) => key === pathParam.key,
            )
            let found = Object.values(mapReceiveKey)[foundIndex]
            if (!found) return false
            return data[found] == jsonForm.formData[pathParam.param]
          }
        })
        if (found) return data
        return false
      })

      // found data
      if (foundIndex > -1) {
        return newData[formName][foundIndex]
      }
    }
  }
  return {}
}

const replaceValue = (value) => {
  return value.replace(/({|})/g, '')
}

const getRequestType = (schema, request) => {
  if (!schema || !request) return

  return request.split('.').reduce((current, key) => {
    return current?.properties?.[key]
  }, schema)?.type
}

export const setRequestData = (
  action,
  jsonForm,
  rowData,
  datasourceValue,
  user,
  tableColumn,
  apiSchema,
) => {
  let requestData = {}
  let {
    requestDataType,
    mapReceive = {},
    mapSend = {},
    json,
    mapParam = {},
    mapData = {},
    mapOther = {},
    isGroup,
    groupData = [],
    customData = [],
  } = action
  let formData = jsonForm.formData

  if (requestDataType === 'formData') {
    requestData = json
    if (isGroup) {
      groupData.forEach((item) => {
        let { jsonKey, mapData, mapParam, mapSend = {}, mapReceive = {} } = item
        Object.keys(mapData).forEach((item) => {
          let paramName = mapParam[item]
          let sendName = replaceValue(mapSend[item] ?? mapReceive[item])

          if (sendName === paramName) {
            paramName = jsonKey ? `${jsonKey}.${paramName}` : paramName
            let value = objectPath.get(rowData, paramName)
            objectPath.set(requestData, paramName, value)
          } else {
            paramName = jsonKey ? `${jsonKey}.${paramName}` : paramName
            if (/\./.test(sendName) === false) {
              sendName = jsonKey ? `${jsonKey}.${sendName}` : sendName
            }
            if (mapOther[item]) {
              paramName = mapOther[item].name
              let dataType = mapOther[item].dataType
              if (dataType === 'dataTime') {
                let value = mapOther[item].value
                let now = null
                if (value === 'currentDate') {
                  now = moment().format('YYYY-MM-DD')
                } else if (value === 'currentTime') {
                  now = moment().format('HH:mm:ss')
                } else if (value === 'currentDateTime') {
                  now = moment().format('YYYY-MM-DD HH:mm:ss')
                }
                objectPath.set(requestData, sendName, now)
              } else {
                let value = objectPath.get(rowData, paramName)
                objectPath.set(requestData, sendName, value)
              }
            }
            if (sendName !== paramName) {
              objectPath.del(requestData, paramName)
            }
          }
        })
      })
    } else {
      Object.keys(mapData).forEach((item) => {
        let paramName = mapParam[item]
        let sendName = replaceValue(mapSend[item] ?? mapReceive[item])
        if (sendName === paramName) {
          let value = objectPath.get(rowData, paramName)
          objectPath.set(requestData, paramName, value)
        } else {
          if (mapOther[item]) {
            paramName = mapOther[item].name
            let dataType = mapOther[item].dataType
            if (dataType === 'dataTime') {
              let value = mapOther[item].value
              let now = null
              if (value === 'currentDate') {
                now = moment().format('YYYY-MM-DD')
              } else if (value === 'currentTime') {
                now = moment().format('HH:mm:ss')
              } else if (value === 'currentDateTime') {
                now = moment().format('YYYY-MM-DD HH:mm:ss')
              }
              objectPath.set(requestData, sendName, now)
            } else {
              let value = objectPath.get(rowData, paramName)
              objectPath.set(requestData, sendName, value)
            }
          }
          objectPath.del(requestData, paramName)
        }
      })
    }
  } else {
    let isUseNull = true
    customData.forEach((item) => {
      let {
        request,
        propType,
        value,
        valueType,
        key = '',
        typeField,
        type,
        systemKey,
      } = item
      let format = typeField || type
      if (!propType) return
      if (propType === 'table') {
        let column = tableColumn.find((column) => column.field === key)
        format = column?.typeField || column?.type
        if (format === 'no') {
          value = objectPath.get(rowData, `tableData.${key}`)
        } else if (valueType === 'receive') {
          value = objectPath.get(rowData, key)
        } else {
          value = column?.value
        }
      } else if (propType === 'user') {
        value = objectPath.get(user, 'userId')
      } else if (propType === 'input') {
        value =
          objectPath.get(formData, systemKey) ||
          objectPath.get(formData, request)
      } else if (propType === 'custom') {
      } else if (propType === 'dateTime') {
        let now = null
        if (value === 'currentDate') {
          now = moment().format('YYYY-MM-DD')
        } else if (value === 'currentTime') {
          now = moment().format('HH:mm:ss')
        } else if (value === 'currentDateTime') {
          now = moment().format('YYYY-MM-DD HH:mm:ss')
        }
        value = now
      } else if (propType === 'datasource') {
        format = format ?? 'string'
        value = objectPath.get(datasourceValue, key)
      }
      let requestType =
        getRequestType(apiSchema, request) ||
        getRequestType(action.internalApi?.schema, request)
      value = getCheckValue(
        value,
        requestType === 'string' ? 'string' : format,
        isUseNull,
      )
      if (value !== undefined) {
        value = convertValueBySchema(apiSchema, request, value)
        objectPath.set(requestData, request, value)
      }
    })
  }
  return requestData
}

const upperCase = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const doAfter = (action, response, designContext, uischema) => {
  let { jsonForm, setFormData } = designContext
  let formData = jsonForm.formData
  let afterAction = objectPath.get(action, 'afterAction') || {}
  let { status, data = null } = response || {}
  if (status === null) return
  if (action?.dataTable) {
    let { dataKey = '', dataTable } = action
    let responseData = objectPath.get(data, dataKey)
    dataTable.forEach(({ response, dataType, key, dynamicName }) => {
      if (dataType === 'input') {
        let value = objectPath.get(responseData, response)
        objectPath.set(formData, dynamicName, value)
        objectPath.set(formData, key, value)
      }
    })
  }
  if (uischema) {
    let tableAction = uischema?.tableAction?.action
    if (tableAction) {
      let fetchAction = tableAction.find((item) => item.name === 'fetch') || {}
      if (fetchAction) {
        let { elementAction } = designContext
        onCallAPIAction(
          fetchAction,
          formData,
          elementAction,
          designContext,
          true,
        )
      }
    }
  }
  setNotification(afterAction, response)
  if (afterAction?.isEnabled) {
    let actionList = objectPath.get(afterAction, 'action') || []
    actionList.forEach(async (action) => {
      console.log('afterAction', action.name)
    })
  }
  let afterSuccess = objectPath.get(action, 'afterSuccess') || {}
  if (afterSuccess?.isEnabled) {
    if (status >= 200 && status < 300) {
      let actionList = objectPath.get(afterSuccess, 'action') || []
      actionList.forEach(async (action) => {
        console.log('afterSuccess', action.name)
      })
    }
  }
}

const setNotification = (afterAction, response) => {
  let {
    status,
    data = null,
    message = '',
    api = '',
    apiName = '',
  } = response || {}
  if (afterAction.isNotified) {
    if (status >= 200 && status < 300) {
      let notice = PNotify.success({
        title: afterAction.notifySuccessTitle || 'Success',
        text: afterAction.notifySuccessText,
        icon: 'fas fa-check-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
      console.log(`API Name: ${apiName}`)
    } else {
      let notice = PNotify.error({
        title: afterAction.notifyErrorTitle || 'Error',
        text: JSON.stringify(message, null, 2) || afterAction.notifyErrorText,
        icon: 'fas fa-exclamation-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
      console.error(`Error API Name: ${apiName}`)
    }
  }
}

// ============= INTERNAL FUNCTION ============= //
